"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VoucherState = void 0;
var mobx_1 = require("mobx");
var voucher_1 = require("services/nadesico/voucher");
var isomorphismConstant_1 = require("../../../utils/isomorphismConstant");
var lang_1 = require("../../../utils/lang");
var Modal_1 = require("../../ezUI/Modal");
var app_1 = require("services/page/app");
var index_1 = require("./index");
var login_1 = require("utils/login");
var getLang = lang_1.getEzbuyLang();
var VoucherState;
(function (VoucherState) {
    VoucherState[VoucherState["canReceive"] = 0] = "canReceive";
    VoucherState[VoucherState["Received"] = 1] = "Received";
    VoucherState[VoucherState["ComingSoon"] = 2] = "ComingSoon";
    VoucherState[VoucherState["RanOut"] = 3] = "RanOut";
    VoucherState[VoucherState["Expired"] = 4] = "Expired";
})(VoucherState = exports.VoucherState || (exports.VoucherState = {}));
var VoucherStore = (function () {
    function VoucherStore(vouchers, id) {
        var _this = this;
        this.voucherIds = [];
        this.voucherModules = [];
        this.voucherTypes = [];
        this.warnMsg = "";
        this.getVoucherState = function (voucher) {
            var remainTime = voucher.remainTime, canReceive = voucher.canReceive, remainCount = voucher.remainCount, receivedCount = voucher.receivedCount;
            if (Number(remainTime) < 0) {
                return VoucherState.ComingSoon;
            }
            if (Number(remainTime) === 0) {
                return VoucherState.Expired;
            }
            if (remainCount > 0 && canReceive) {
                return VoucherState.canReceive;
            }
            if (receivedCount > 0) {
                return VoucherState.Received;
            }
            return VoucherState.RanOut;
        };
        this.setWarnMsg = function (message, delay, fn) {
            if (delay === void 0) { delay = 3000; }
            if (_this.warnMsg) {
                return;
            }
            _this.warnMsg = message;
            setTimeout(function () {
                mobx_1.runInAction(function () {
                    _this.warnMsg = "";
                });
                fn && fn();
            }, delay);
        };
        this.claimVoucher = function (voucher, onLogin) { return __awaiter(_this, void 0, void 0, function () {
            var result, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4, voucher_1.Receive({
                                voucherTypeId: voucher.voucherId,
                                channelId: voucher_1.ChannelId.Tights
                            })];
                    case 1:
                        result = _a.sent();
                        if (result && result.code === 200) {
                            Modal_1.default.info({
                                width: 350,
                                content: index_1.getVoucherModalContent(voucher),
                                footer: voucher.info.link ? undefined : null,
                                okText: getLang("GO SHOPPING"),
                                onOK: function () {
                                    location.href = voucher.info.link;
                                }
                            });
                        }
                        else if (result && result.code === 403) {
                            if (onLogin) {
                                onLogin();
                            }
                            else {
                                login_1.showLoginModal(false, false);
                            }
                        }
                        else {
                            this.setWarnMsg(result.message);
                        }
                        this.getMulVouchers();
                        return [3, 3];
                    case 2:
                        e_1 = _a.sent();
                        console.error(e_1);
                        this.setWarnMsg("sorry, something wrong occurred, pls try again later!");
                        return [3, 3];
                    case 3: return [2];
                }
            });
        }); };
        this.getMulVouchers = function (voucherIds) {
            if (voucherIds === void 0) { voucherIds = _this.voucherIds; }
            return __awaiter(_this, void 0, void 0, function () {
                var result_1, e_2;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4, voucher_1.UserGetMultiVoucherType({
                                    voucherTypeIds: voucherIds
                                })];
                        case 1:
                            result_1 = _a.sent();
                            if (result_1 && result_1.voucherTypes) {
                                mobx_1.runInAction("set vouchers", function () {
                                    _this.voucherTypes = result_1.voucherTypes;
                                });
                            }
                            return [3, 3];
                        case 2:
                            e_2 = _a.sent();
                            console.error(e_2);
                            return [3, 3];
                        case 3: return [2];
                    }
                });
            });
        };
        if (vouchers) {
            this.voucherIds = vouchers.map(function (item) { return item.voucherId; });
            this.voucherModules = vouchers;
            this.getMulVouchers();
        }
        else if (!vouchers) {
            if (!id) {
                return;
            }
            app_1.GetFrontModules({
                moduleId: [id],
                meta: {
                    catalog: isomorphismConstant_1.default.country || isomorphismConstant_1.default.countryCode,
                    lang: isomorphismConstant_1.default.language,
                    client: "web",
                    priceSymbol: isomorphismConstant_1.default.currency
                }
            }).then(function (_a) {
                var mods = _a.mods;
                mobx_1.runInAction(function () {
                    if (mods[id] && mods[id].module && mods[id].module.vouchers) {
                        var vouchers_1 = mods[id].module.vouchers;
                        _this.voucherIds = vouchers_1.map(function (item) { return item.voucherId; });
                        _this.voucherModules = vouchers_1;
                        _this.getMulVouchers();
                    }
                });
            }, function (err) {
                console.error(err);
                return null;
            });
        }
    }
    Object.defineProperty(VoucherStore.prototype, "vouchers", {
        get: function () {
            var _this = this;
            return this.voucherModules.reduce(function (memo, item) {
                var voucherType = _this.voucherTypes.find(function (i) { return i.id === item.voucherId && !i.isServerSend; });
                if (voucherType) {
                    return memo.concat(__assign(__assign(__assign({}, item), voucherType), { voucherState: _this.getVoucherState(voucherType) }));
                }
                return memo;
            }, []);
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        mobx_1.observable
    ], VoucherStore.prototype, "voucherModules", void 0);
    __decorate([
        mobx_1.observable
    ], VoucherStore.prototype, "voucherTypes", void 0);
    __decorate([
        mobx_1.observable
    ], VoucherStore.prototype, "warnMsg", void 0);
    __decorate([
        mobx_1.computed
    ], VoucherStore.prototype, "vouchers", null);
    __decorate([
        mobx_1.action
    ], VoucherStore.prototype, "setWarnMsg", void 0);
    __decorate([
        mobx_1.action
    ], VoucherStore.prototype, "claimVoucher", void 0);
    __decorate([
        mobx_1.action
    ], VoucherStore.prototype, "getMulVouchers", void 0);
    return VoucherStore;
}());
exports.default = VoucherStore;
